import styled from 'styled-components';
import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxProps as AntdCheckboxProps } from 'antd/lib/checkbox';
import theme from '../theme';

export type CheckboxProps = AntdCheckboxProps;

export const Checkbox = styled(AntdCheckbox)`
  * {
    border-radius: ${theme.getBorderRadius('small')};
  }
`;

export default Checkbox;
